import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'

import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);



class Discover extends Component {

  constructor(element) {

    super(element)

    this.body = document.body
    this.element = element
    this.i = 0


    this.ref = {
      video: null,
      mask: null
    }

  }

  mount() {

     gsap.fromTo(this.ref.mask, {
       clipPath: `polygon( 74.333% 19.847%,74.333% 19.847%,73.605% 19.009%,72.83% 18.249%,72.013% 17.569%,71.158% 16.972%,70.269% 16.461%,69.351% 16.036%,68.407% 15.701%,67.442% 15.458%,66.46% 15.308%,65.465% 15.254%,46.583% 15.254%,46.583% 15.254%,45.609% 15.301%,44.647% 15.439%,43.701% 15.667%,42.774% 15.983%,41.872% 16.385%,40.996% 16.871%,40.152% 17.439%,39.344% 18.088%,38.574% 18.815%,37.847% 19.619%,37.847% 19.619%,37.179% 20.482%,36.569% 21.401%,36.021% 22.371%,35.536% 23.388%,35.115% 24.446%,34.759% 25.541%,34.471% 26.668%,34.252% 27.823%,34.104% 29%,34.028% 30.195%,22.014% 30.195%,22.014% 69.178%,22.014% 69.178%,22.024% 69.793%,22.053% 70.405%,22.101% 71.015%,22.169% 71.622%,22.255% 72.224%,22.36% 72.82%,22.484% 73.41%,22.626% 73.994%,22.787% 74.569%,22.965% 75.136%,22.965% 75.136%,23.164% 75.697%,23.379% 76.248%,23.611% 76.788%,23.861% 77.316%,24.126% 77.832%,24.407% 78.334%,24.704% 78.823%,25.017% 79.298%,25.345% 79.758%,25.688% 80.203%,25.688% 80.203%,26.044% 80.627%,26.413% 81.032%,26.795% 81.418%,27.188% 81.786%,27.593% 82.135%,28.008% 82.463%,28.433% 82.772%,28.868% 83.061%,29.312% 83.329%,29.764% 83.576%,29.764% 83.576%,30.227% 83.801%,30.696% 84.001%,31.169% 84.176%,31.647% 84.328%,32.129% 84.457%,32.615% 84.561%,33.104% 84.642%,33.595% 84.7%,34.088% 84.734%,34.583% 84.746%,65.979% 84.746%,65.979% 69.805%,65.979% 69.805%,66.938% 69.707%,67.882% 69.519%,68.809% 69.245%,69.713% 68.886%,70.591% 68.444%,71.44% 67.921%,72.255% 67.321%,73.032% 66.643%,73.768% 65.892%,74.458% 65.068%,74.458% 65.068%,75.104% 64.169%,75.689% 63.217%,76.213% 62.214%,76.672% 61.168%,77.066% 60.082%,77.392% 58.961%,77.649% 57.812%,77.835% 56.638%,77.948% 55.445%,77.986% 54.237%,77.986% 30.881%,77.986% 30.881%,77.951% 29.644%,77.837% 28.423%,77.647% 27.223%,77.382% 26.049%,77.045% 24.907%,76.637% 23.801%,76.16% 22.737%,75.616% 21.72%,75.006% 20.755%,74.333% 19.847%,34.132% 69.703%,34.132% 30.288%,65.889% 30.288%,65.889% 69.703%,34.132% 69.703% )`
     }, {

       clipPath: `polygon( 63.889% 32.788%,63.889% 32.788%,63.473% 32.309%,63.03% 31.876%,62.564% 31.488%,62.076% 31.148%,61.569% 30.856%,61.044% 30.614%,60.506% 30.423%,59.955% 30.285%,59.394% 30.2%,58.826% 30.169%,48.049% 30.169%,48.049% 30.169%,47.493% 30.196%,46.944% 30.275%,46.404% 30.405%,45.876% 30.585%,45.36% 30.815%,44.861% 31.092%,44.379% 31.417%,43.917% 31.787%,43.478% 32.202%,43.063% 32.661%,43.063% 32.661%,42.681% 33.153%,42.334% 33.677%,42.021% 34.231%,41.744% 34.811%,41.503% 35.414%,41.301% 36.039%,41.136% 36.682%,41.011% 37.341%,40.926% 38.013%,40.882% 38.695%,34.028% 38.695%,34.028% 60.949%,34.028% 60.949%,34.033% 61.3%,34.05% 61.649%,34.078% 61.997%,34.116% 62.343%,34.166% 62.686%,34.226% 63.027%,34.296% 63.364%,34.377% 63.696%,34.468% 64.024%,34.569% 64.347%,34.569% 64.347%,34.683% 64.667%,34.806% 64.982%,34.939% 65.289%,35.081% 65.59%,35.233% 65.885%,35.393% 66.171%,35.563% 66.45%,35.742% 66.721%,35.929% 66.984%,36.125% 67.237%,36.125% 67.237%,36.329% 67.479%,36.54% 67.71%,36.757% 67.93%,36.982% 68.14%,37.213% 68.339%,37.45% 68.527%,37.692% 68.703%,37.94% 68.867%,38.193% 69.02%,38.451% 69.161%,38.451% 69.161%,38.716% 69.289%,38.983% 69.403%,39.253% 69.504%,39.525% 69.591%,39.8% 69.664%,40.077% 69.724%,40.356% 69.771%,40.637% 69.804%,40.919% 69.824%,41.201% 69.831%,59.118% 69.831%,59.118% 61.305%,59.118% 61.305%,59.665% 61.249%,60.203% 61.142%,60.732% 60.985%,61.248% 60.781%,61.749% 60.529%,62.234% 60.231%,62.699% 59.888%,63.143% 59.501%,63.563% 59.072%,63.958% 58.602%,63.958% 58.602%,64.327% 58.089%,64.661% 57.546%,64.96% 56.974%,65.222% 56.377%,65.447% 55.757%,65.633% 55.118%,65.78% 54.462%,65.886% 53.793%,65.951% 53.112%,65.972% 52.424%,65.972% 39.085%,65.972% 39.085%,65.952% 38.379%,65.887% 37.682%,65.779% 36.998%,65.628% 36.328%,65.436% 35.676%,65.203% 35.045%,64.931% 34.438%,64.621% 33.857%,64.273% 33.306%,63.889% 32.788%,40.944% 61.246%,40.944% 38.746%,59.069% 38.746%,59.069% 61.246%,40.944% 61.246% )`,

       scrollTrigger: {
         trigger: this.element,
         start: "top top+=80%",
         end: "bottom top+=50%",
         scrub: true
       }
     })
   

    }    



    resize(){

       


       

    }

    unmount() {



    }

}

module.exports = Discover



